import React, { useEffect, useState } from 'react'
import { ProductCategoriesPageProps } from '../../../types/app/categoriesTypes'
import { LoadingItem } from '../../../shared/components/loading';
import { AlertMsg } from '../../../shared/components/alert-msg';
import { appConstants } from '../../../redux/action-constants/inapp.constants';
import ReportDisplay from './ReportDisplay';
import { useLocation, useNavigate } from 'react-router-dom';

export interface ActionProps {
    pageProps: ProductCategoriesPageProps;
    payload?: string | "CLEAR" | { id: number; name: string | null } | { name: string };
    id?: number;
}

const getProductCategoriesAction = async ({ pageProps, payload }: ActionProps) => {

    await pageProps.getProductCategoriesAction(payload as string);
}
const deleteProductCategoryAction = async ({ pageProps, id, payload }: ActionProps) => {
    await pageProps.deleteProductCategoryAction(id as number, payload as "CLEAR")
}
const createProductCategoryAction = async ({ pageProps, payload }: ActionProps) => {
    await pageProps.createProductCategoryAction(payload as { name: string })

}
const updateProductCategoryAction = async ({ pageProps, payload }: ActionProps) => {
    await pageProps.updateProductCategoryAction(payload as { name: string; id: number })
}
const InAppContent = ({ pageProps }: { pageProps: ProductCategoriesPageProps }) => {
    const [selected, setSelected] = useState<number[]>([]);
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set("page", pageNumber.toString());
        navigate(`?${params.toString()}`, { replace: true });
    }, [pageNumber, location.search, navigate]);

    useEffect(() => {
        deleteProductCategoryAction({
            pageProps,
            payload: "CLEAR"
        })
        createProductCategoryAction({
            pageProps,
            payload: "CLEAR"
        })
    }, [])

    const [searchTerm, setSearchTerm] = useState<string>("");
    const [searchValue, setSearchValue] = useState<string>("");
    const [isSearchLoading, setSearchLoading] = useState<boolean>(false)


    useEffect(() => {
        getProductCategoriesAction({ pageProps, payload: `Page=${pageNumber}&Size=100&Name=${searchTerm}` }).then(() => {
            setSearchLoading(false)
        })
    }, [pageNumber, searchTerm]);

    useEffect(() => {
        if (pageProps?.createProductCategoryRequest?.request_status === appConstants.CREATE_STORE_CATEGORY_SUCCESS) {
            setShowCreateModal(false)
            getProductCategoriesAction({ pageProps, payload: `Page=${pageNumber}&Size=100&Name=${searchTerm}` })
            createProductCategoryAction({
                pageProps,
                payload: "CLEAR"
            })
        }
    }, [pageProps?.createProductCategoryRequest?.request_status, pageNumber, searchTerm])

    const toggleSelect = (id: number) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
        );
    };

    const handleSearch = (value: string) => {
        setSearchLoading(true)
        setSearchTerm(value)
    }

    const handleDeleteCategory = (id: number) => {
        deleteProductCategoryAction({ pageProps, id }).then(() => {
            if (pageProps?.deleteProductCategoryRequest?.request_status === appConstants.DELETE_STORE_CATEGORY_SUCCESS) {
                getProductCategoriesAction({ pageProps, payload: `Page=${pageNumber}&Size=100&Name=${searchTerm}` })
            }
        })
    }

    const handleCreateCategory = (payload: { name: string }) => {
        createProductCategoryAction({ pageProps, payload })
    }

    const handleUpdateCategory = (payload: { name: string;  id:number}) => {
        updateProductCategoryAction({ pageProps, payload }).then(() => {
            if (pageProps?.updateProductCategoryRequest?.request_status === appConstants.UPDATE_STORE_CATEGORY_SUCCESS) {
                getProductCategoriesAction({ pageProps, payload: `Page=${pageNumber}&Size=100&Name=${searchTerm}` })
            }
        })
    }


    const handleClearOrSelectAll = () => {
        if (selected.length === pageProps?.getProductCategoriesRequest?.request_data?.response?.results?.length) {
            setSelected([])
        } else {
            const Ids: number[] = []
            pageProps?.getProductCategoriesRequest?.request_data?.response?.results?.map(value => {
                Ids.push(value.id)
            })
            setSelected(Ids)
        }
    }

    const handlePageClick = (event: any) => {

        setPageNumber(event?.selected + 1)

    }

    const handleCloseCreateModal = () => {
        setShowCreateModal(false)
        createProductCategoryAction({
            pageProps,
            payload: "CLEAR"
        })
    }

    const handleOpenCreateModal = () => {
        createProductCategoryAction({
            pageProps,
            payload: "CLEAR"
        })
        setShowCreateModal(true)
    }


    return (
        <div className="inapp-content">
            <div className="page-content dashboard">
                {(pageProps?.getProductCategoriesRequest?.request_status === appConstants.GET_STORE_CATEGORIES_PENDING && !isSearchLoading) &&
                    <LoadingItem />
                }
                {pageProps?.deleteProductCategoryRequest?.request_status === appConstants.DELETE_STORE_CATEGORY_FAILURE &&
                    <AlertMsg type="error" message={pageProps.deleteProductCategoryRequest?.request_data.error} />
                }
                {pageProps?.deleteProductCategoryRequest?.request_status === appConstants.DELETE_STORE_CATEGORY_SUCCESS &&
                    <AlertMsg type="success" message="Successfully Deleted Category" />
                }
                {pageProps?.updateProductCategoryRequest?.request_status === appConstants.UPDATE_STORE_CATEGORY_FAILURE &&
                    <AlertMsg type="error" message={pageProps.updateProductCategoryRequest?.request_data.error} />
                }
                {
                    (
                        pageProps?.getProductCategoriesRequest?.request_status === appConstants.GET_STORE_CATEGORIES_SUCCESS || isSearchLoading
                    ) &&
                    <ReportDisplay
                        pageProps={pageProps}
                        selected={selected}
                        toggleSelect={toggleSelect}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                        onSearch={handleSearch}
                        isSearchLoading={isSearchLoading}
                        clearOrAllSelection={handleClearOrSelectAll}
                        page={pageNumber}
                        handlePageClick={handlePageClick}
                        handleDeleteCategory={handleDeleteCategory}
                        handleCreateCategory={handleCreateCategory}
                        handleUpdateCategory={handleUpdateCategory}
                        showCreateModal={showCreateModal}
                        onOpenCreateModal={handleOpenCreateModal}
                        onCloseCreateModal={handleCloseCreateModal}
                        createCategorySubmitting={pageProps?.createProductCategoryRequest?.is_request_processing}
                        createCategoryError={pageProps?.createProductCategoryRequest?.request_status === appConstants.CREATE_STORE_CATEGORY_FAILURE ? pageProps?.createProductCategoryRequest?.request_data?.error : ""}
                    />
                }
                {pageProps.getProductCategoriesRequest.request_status === appConstants.GET_STORE_CATEGORIES_FAILURE &&
                    <AlertMsg type="error" message={pageProps.getProductCategoriesRequest?.request_data.error} />
                }

            </div>
        </div>
    )
}

export default InAppContent
